<template>
  <el-dialog
    center
    :title="$t('common.cashRechargeTitle')"
    :custom-class="cashRechargeDialogClass"
    :visible.sync="isDialogVisiblePay"
    @close="closeDialog"
    :width="cashRechargeDialogWidth"
  >
    <template v-if="judgement || Choice === ''">
      <el-form
        :label-width="formLabelWidth"
        :class="['cash-recharge-form', { 'cash-recharge-form--en': isUsLocale }]"
      >
        <el-form-item :label="$t('common.amount')">
          <el-input-number
            v-model="money"
            @change="handleChange"
            :min="0"
            :step="1000"
            :label="$t('common.amount')"
          ></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('common.label')">
          <ul class="payment-method-ul">
            <!-- 美版（en-US）仅对公转账，不展示支付宝 / 微信 -->
            <li
              v-if="!isUsLocale"
              @click="PaymentEvent('mixue_alipay_code')"
            >
              <img src="@/assets/images/procure2Pay/zhifubao2.png" alt="" />
              <span
                class="select-icon"
                v-if="payType == 'mixue_alipay_code'"
              ></span>
            </li>
            <li
              v-if="!isUsLocale"
              @click="PaymentEvent('mixue_wechat_code')"
            >
              <img src="@/assets/images/procure2Pay/weixinzhifu1.png" alt="" />
              <span
                class="select-icon"
                v-if="payType == 'mixue_wechat_code'"
              ></span>
            </li>
            <li
              class="bank-transfer-item"
              :class="{ 'bank-transfer-item--en': isUsLocale }"
              @click="PaymentEvent('bank')"
            >
              <img
                v-if="!isUsLocale"
                class="yin"
                src="@/assets/images/procure2Pay/transfer.jpg"
                alt=""
              />
              <span class="bank-transfer-label">{{ $t('app.auto_193_4fec09ce') }}</span>
              <span class="select-icon" v-if="payType == 'bank'"></span>
            </li>
          </ul>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ImmediateRecharge"
          >{{ $t('app.auto_194_a5ebb961') }}</el-button
        >
      </span>
    </template>
    <!--支付宝-->
    <template v-if="visible && Choice === 'mixue_alipay_code'">
      <div class="cash-pay-box">
        <p class="pay-num">支付{{ $crmCurrencySymbol() }}{{ money || 2000 }}{{ $crmCurrencySuffix() }}</p>
        <div
          v-if="visible && Choice === 'mixue_alipay_code' && payUrl.length > 0"
          class="qrcode-box"
        >
          <div class="qr-code" ref="qrCodeUrl"></div>
        </div>
        <p class="choose-type">{{ $t('app.auto_188_6a461e5c') }}</p>
      </div>
    </template>
    <!--微信-->
    <template v-if="visible && Choice === 'mixue_wechat_code'">
      <div class="cash-pay-box">
        <p class="pay-num">支付{{ $crmCurrencySymbol() }}{{ money || 2000 }}{{ $crmCurrencySuffix() }}</p>
        <div
          v-if="visible && Choice === 'mixue_wechat_code' && payUrl.length > 0"
          class="qrcode-box"
        >
          <div class="qr-code" ref="qrCodeUrl"></div>
        </div>
        <p class="choose-type">{{ $t('app.auto_187_8434ac96') }}</p>
      </div>
    </template>
    <!--对公转账-->
    <template v-if="visible && Choice === 3">
      <div class="transfer-accounts-box"></div>
    </template>
    <template v-if="vvvvv === 1">
      <p>{{ $t('app.auto_192_0bca3c45') }}</p>
    </template>
    <template v-if="status === 1 && !modalCK">
      <div class="cash-success-box">
        <img src="@/assets/images/payment/OK.png" />
        <p class="success-tips">{{ $t('app.auto_198_001d1ca7') }}</p>
        <el-button type="primary" round @click="ContinueRecharge"
          >{{ $t('app.complete') }}</el-button
        >
      </div>
    </template>
  </el-dialog>
</template>

<script>
import {
  queryAgentAccount,
  getStudyPayStatus,
  agentSingleStudyPayUrl
} from "@/api/AccountInterface";
import { getAgentRegionFee } from "@/api/AgentAccount";
import QRCode from "qrcodejs2-fix";

export default {
  data() {
    return {
      isDialogVisiblePay: false,
      selectedRows: [], //认购区域
      modalCK: false,
      message: "",
      weixin: false,
      zhifubao: true,
      vvvvv: 0,
      sign: 2,
      money: 0,
      Data: [],
      flowId: "", //支付流水号
      userName: "", //操作人
      payTime: "", //充值时间
      amount: "", //充值金额
      payMethodText: "", //支付方式解释
      rechargeId: "", //订单编号
      payUrl: "", //二维码地址
      account: "", //账户余额
      judgement: true, //一页面  是否显示判断值
      WeChat: false, //微信
      Alipay: false, //支付宝
      visible: false, //选择支付方式
      previewVisible: false,
      previewImage: "",
      Choice: "mixue_alipay_code", //选择支付方式  1 微信   2 支付宝
      bodylist: [],
      payType: "mixue_alipay_code", //选择了支付方式  1 微信   2 支付宝 3 银行转账
      accountss: "", //充值了多少金额
      data: "",
      status: "", //扫码成功接口返回值Initialization
      Initia: ""
    };
  },
  props: {
    showCashRechargeDialog: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    showCashRechargeDialog: {
      handler(newVal, oldVal) {
        console.log("xxx-1", newVal, oldVal);
        this.isDialogVisiblePay = newVal;
        // 弹窗打开且为美版时默认对公转账（与下方 v-if 隐藏扫码方式一致）
        if (newVal && this.isUsLocale) {
          this.PaymentEvent("bank");
        }
      },
      immediate: true
    }
  },
  computed: {
    isUsLocale() {
      return this.$i18n.locale === "en-US";
    },
    formLabelWidth() {
      return this.isUsLocale ? "168px" : "110px";
    },
    cashRechargeDialogWidth() {
      return this.isUsLocale ? "760px" : "698px";
    },
    cashRechargeDialogClass() {
      return this.isUsLocale
        ? "MyDialog cashRecharge cashRecharge--en"
        : "MyDialog cashRecharge";
    }
  },
  mounted() {
    this.Alipay = true;
    // 美版无支付宝/微信入口，默认银行转账；国内默认支付宝
    if (this.isUsLocale) {
      this.PaymentEvent("bank");
    } else {
      this.PaymentEvent("mixue_alipay_code");
    }
    this.Initialization();
  },
  methods: {
    handleChange() {},
    Initialization(cb) {
      cb && cb(true);
    },
    PaymentEvent(type) {
      this.payType = type;
      this.Choice = type;
    },
    ImmediateRecharge() {
      if (this.payType == "bank") {
        // 对公转账
        this.$emit(
          "closeCashRechargeDialog",
          "needBankRransferModal",
          this.money
        );
        return;
      }

      let params = {
        amount: this.Self_Use ? 1 : this.money || 0.01,
        payMethod: this.payType
      };
      agentSingleStudyPayUrl(params).then(ret => {
        if (ret.code === 0) {
          this.randCodeForpay = ret.data.randCodeForpay; //支付码
          this.campusId = ret.data.campusId; //代理商ID
          this.payUrl = ret.data.object.qr_code || ret.data.object.code_url; //二维码支付链接
          this.rechargeId = ret.data.rechargeId || ""; //订单编号
          this.message = ret.message; //提示
          this.visible = true; //微信支付和 支付宝支付 页面页面是否显示判断值   true or false
          this.judgement = false;
          // 生成二维码
          this.creatQrCode();
          this.Transfer();
        }

        if (ret.message != '成功' && ret.message != 'Success') {
          this.$message.error(this.$getCodeMessage(ret.code, ret.message, ret.messageArgs));
        }
      });
    },
    creatQrCode() {
      this.$nextTick(() => {
        new QRCode(this.$refs.qrCodeUrl, {
          text: this.payUrl, // 二维码的内容
          width: 150,
          height: 150,
          colorDark: "#000",
          colorLight: "#fff",
          correctLevel: QRCode.CorrectLevel.H
        });
      });
    },
    Transfer() {
      this.Initia = setInterval(() => {
        getStudyPayStatus({ rechargeId: this.rechargeId }).then(ret => {
          if (ret.code === 0) {
            if (ret.data) {
              clearInterval(this.Initia);
              this.visible = false;
              this.Choice = 3;
              this.status = 1;
              this.Initialization();
            }
          }
        });
      }, 3000);
    },
    closeDialog() {
      this.isDialogVisiblePay = false;
      this.$emit("closeCashRechargeDialog");
    },
    ContinueRecharge() {
      this.isDialogVisiblePay = false;
      this.$emit("closeCashRechargeDialog");
    }
  },
  beforeDestroy() {
    this.Initia && clearInterval(this.Initia);
  }
};
</script>

<style lang="scss" scoped>
.payment-method-ul {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  li {
    position: relative;
    width: 140px;
    height: 52px;
    border-radius: 5px;
    margin: 0 16px 8px 0;
    border: 1px solid rgb(103, 99, 99);
    border-radius: 5px;
    line-height: 52px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    flex-shrink: 0;
    box-sizing: border-box;
    &.bank-transfer-item {
      width: auto;
      min-width: 168px;
      max-width: 240px;
      padding: 0 10px;
      justify-content: flex-start;
      gap: 8px;
      line-height: normal;
      &.bank-transfer-item--en {
        justify-content: center;
        text-align: center;
      }
    }
    img {
      width: 117px;
      flex-shrink: 0;
      // height: 40px;
      &.yin {
        width: 54px;
      }
    }
    .bank-transfer-label {
      white-space: nowrap;
      line-height: 1.2;
      font-size: 13px;
    }
    .select-icon {
      position: absolute;
      width: 23px;
      height: 23px;
      background: url("@/assets/images/procure2Pay/cornerMark.png") no-repeat;
      right: 0;
      bottom: 0;
      background-size: 100% 100%;
    }
  }
}

.cash-recharge-form--en {
  ::v-deep .el-form-item__label {
    font-size: 15px;
  }
  ::v-deep .el-input-number .el-input__inner {
    font-size: 15px;
  }
  .payment-method-ul .bank-transfer-label {
    font-size: 15px;
  }
}
.cash-pay-box {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  .pay-num {
    font-size: 24px;
    color: red;
    font-weight: 600;
    margin-bottom: 20px;
  }
  .qr-code {
    border: solid 2px #efefef;
    padding: 20px;
  }
  .choose-type {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4c4c4c;
    margin-top: 5px;
  }
}
.cash-success-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  .success-tips {
    margin-bottom: 20px;
    font-size: 24px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(76, 76, 76, 1);
  }
}
</style>
<style lang="scss">
.cashRecharge {
  .el-input-number {
    width: 280px;
  }
  .cash-recharge-form {
    .el-form-item__label {
      white-space: nowrap;
    }
  }
  &.cashRecharge--en {
    .el-dialog__title {
      font-size: 18px;
      line-height: 1.35;
    }
    .dialog-footer .el-button {
      font-size: 15px;
    }
  }
}
</style>
